import { useEffect, useState } from "react";

import type { EmblaCarouselType } from "embla-carousel";

type UseDotButtonType = {
  selectedIndex: number;
  scrollSnaps: number[];
  onDotButtonClick: (index: number) => void;
};

export const useDotButton = (
  emblaApi: EmblaCarouselType | undefined,
  onButtonClick?: (emblaApi: EmblaCarouselType) => void,
): UseDotButtonType => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [scrollSnaps, setScrollSnaps] = useState<number[]>([]);

  const onDotButtonClick = (index: number) => {
    if (!emblaApi) return;
    emblaApi.scrollTo(index);
    onButtonClick?.(emblaApi);
  };

  useEffect(() => {
    if (!emblaApi) return;

    const handleInit = (api: EmblaCarouselType) => {
      setScrollSnaps(api.scrollSnapList());
    };

    const handleSelect = (api: EmblaCarouselType) => {
      setSelectedIndex(api.selectedScrollSnap());
    };

    handleInit(emblaApi);
    handleSelect(emblaApi);

    emblaApi.on("reInit", () => {
      handleInit(emblaApi);
      handleSelect(emblaApi);
    });
    emblaApi.on("select", handleSelect);

    return () => {
      emblaApi.off("reInit", () => {
        handleInit(emblaApi);
        handleSelect(emblaApi);
      });
      emblaApi.off("select", handleSelect);
    };
  }, [emblaApi]);

  return {
    selectedIndex,
    scrollSnaps,
    onDotButtonClick,
  };
};
